<template>
    <el-dialog
            title="设置音量"
            :visible.sync="dialogVisible"
            width="30%"
            :befor-close='closeDialog'
            :show-close="showClo"
            :close-on-click-modal="showClo"
            :close-on-press-escape="showClo">
        <el-slider
                v-model="value"
                show-input>
        </el-slider>
        <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="setVol(value)" >确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>
    export default {
        name:'setValue',
        data(){
            return{
                value: this.volValue,
                showClo:false,
            }
        },
        watch:{
            dialogVisible: {
                handler() {
                    this.value = this.volValue
                }
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
            volValue: {
                type: Number,
            },
        },

       methods: {
           setVol(data){
               this.$emit("setValue", data);
           },
           closeDialog(){
               this.$emit("closeDialog");
           }
       }
    }
</script>